import React from 'react';
import useStyles from './useStyles';
import PropTypes from 'prop-types';
import moment from 'moment';

function CandidateListItem({ conversation, selectedConversation, setSelectedConversation }) {

  const classes = useStyles();
  
  return (
    <div
      className={`${classes.root} ${selectedConversation[0].id === conversation.id ? 'selected': ''}`}
      onClick={() => setSelectedConversation([conversation])}
    >
      <div className={classes.details}>
        <div className={classes.name}>
          <h4>{ conversation.candidate_name }</h4>
        </div>
        <div className={classes.time}>{ conversation.messages.length > 0 && conversation.messages[0].sent_time && moment(conversation.messages[0].sent_time).fromNow() }</div>
      </div>
      <p className={classes.excerpt}>
        {conversation.messages.length > 0 ? conversation.messages[0].body : 'No messages'}
      </p>
    </div>
  )
}

CandidateListItem.propTypes = {
  conversation: PropTypes.object.isRequired,
  selectedConversation: PropTypes.array.isRequired,
  setSelectedConversation: PropTypes.func.isRequired,
}

export default CandidateListItem
